// Module
var code = "<a class=\"md-button abx-button\"> <i class=\"material-icons md-18\"></i> <ng-transclude></ng-transclude> </a> ";
// Exports
module.exports = code;